import { useSyncExternalStore } from 'react';
let pending = 0;
const listeners = new Set<() => void>();
export function beginWorkspaceOperation() {
  pending += 1;
  listeners.forEach(fn => fn());
  let finished = false;
  return () => {
    if (finished) return;
    finished = true;
    pending -= 1;
    listeners.forEach(fn => fn());
  };
}
export const workspaceOperationPending = () => pending > 0;
export function useWorkspaceOperationPending() {
  return useSyncExternalStore(fn => { listeners.add(fn); return () => { listeners.delete(fn); }; }, workspaceOperationPending);
}
